<div class="page-header">
  <div class="page-header-image rellax-header" data-rellax-speed="-7" style="background-image: url('./assets/img/sections/uriel-soberanes.jpg')">

  </div>
    <div class="filter"></div>
    <div class="content-center">
        <div class="motto">
            <h1 class="title-uppercase text-center">Paper Kit</h1>
            <h3 class="text-center">Make your mark with a new design.</h3>
            <br/>
            <a href="javascript:void(0)" class="btn btn-warning btn-round btn-lg">
                <i class="fa fa-share-alt" aria-hidden="true"></i> Share Article
            </a>
        </div>
    </div>
</div>

<div class="wrapper">
    <div class="main">
        <div class="section section-white">
            <div class="container">
                <div class="row">
                    <div class="col-md-6 ml-auto mr-auto text-center title">
                        <h2>A place for storytelling</h2>
                        <h3 class="title-uppercase"><small>Written by designers for designers</small></h3>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 ml-auto mr-auto">
                        <div class="text-center">
                            <span class="label label-warning main-tag">Trending</span>
                            <a href="javascrip: void(0);"><h3 class="title">Make Somebody Nervous Before You Die</h3></a>
                            <h6 class="title-uppercase">October 10, 2016</h6>
                        </div>
                    </div>
                    <div class="col-md-8 ml-auto mr-auto">
                        <a>
                            <div class="card" data-radius="none" style="background-image: url('./assets/img/sections/daniel-olahs.jpg');"></div>
                            <p class="image-thumb text-center">Photo by Cam Adams</p>
                        </a>
                        <div class="article-content">
                            <h4>Follow unconventional beliefs</h4>
                            <p>
                             You won’t find many concepts that are very useful or important if you insist on having a worldview that’s void of controversy, invulnerable to criticism, and incapable of making others feel confused.
                            </p>

                            <p>
                                Interesting ideas are a reward for not being afraid to have unconventional beliefs.
                                You can’t grow if you’re never willing to turn your back on the status quo. You can’t expand if you’re never willing to take an unorthodox stand. You can’t have a beautiful mind if you’re never willing to leave the crowd behind.
                            </p>
                            <blockquote class="blockquote">
                              <p>"Don’t settle: Don’t finish crappy books. If you don’t like the menu, leave the restaurant. If you’re not on the right path, get off it."</p>
                              <footer>- Chris Brogan in <cite title="Source Title">Trust Agents</cite></footer>
                            </blockquote>
                            <p>
                            It’s easier to fear rejection than it is to open our minds to something new, but doing what’s easy doesn’t always equal doing what’s authentic, enriching, and meaningful.
                            </p>
                            <div class="row">
                                <div class="col-md-6">
                                    <a href="javascrip: void(0);">
                                        <div class="card" data-radius="none" style="background-image: url('./assets/img/sections/sebastien-gabrieles.jpg');">
                                            </div> <!-- end card -->
                                    </a>
                                </div>
                                <div class="col-md-6">
                                    <a href="javascrip: void(0);">
                                        <div class="card" data-radius="none" style="background-image: url('./assets/img/sections/john-towner.jpg');"></div>
                                    </a>
                                </div>
                            </div>
                            <p>

                            </p>
                            <h4>Ideas Worth Mentioning</h4>
                            <p>The stories, ideas and lessons are enough to fill a year’s worth of articles, but for now I wanted to share the ideas straight from the people creating the disruption. Below are my most impactful takeaways from the last few days: </p>
                            <p><strong>No one belongs here more than me.</strong> When in doubt of your surroundings, this is the mantra.</p>
                            <p><strong>The ultimate currency is being uncool.</strong> Be vulnerably you and watch how you connect.</p>
                            <p><strong>The opposite of scarcity is enough.</strong> Be confident that if you’re doing work that matters to you, you are enough. There is no comparison.</p>
                            <p><strong>Unused creativity is not benign</strong> – it turns into grief. Do something with it.</p>
                            <p><strong>Get in the arena</strong>, show up, do your thing and don’t be afraid to get your ass kicked a little bit.</p>
                            <p>Who you are will always trump who you think people want you to be.</p>
                            <p><strong>You can’t control if someone loves you back.</strong> Love them anyway.</p>

                            <h4><strong>Conclusions</strong></h4>
                            <p>If all of your convictions can be expressed in a sound bite on mainstream television without provoking the slightest bit of anger or annoyance in anyone whatsoever, I think it’s safe to say that your outlook on life offers you very few opportunities for the remarkable.
                            </p>
                        </div>
                        <br/>
                        <div class="article-footer">
                            <div class="container">
                                <div class="row">
                                    <div class="col-md-6">
                                        <h5>Tags:</h5>
                                        <span class="label label-default">Motivational</span>
                                        <span class="label label-default">Newsletter</span>
                                        <span class="label label-warning">Trending</span>
                                    </div>
                                    <div class="col-md-4 ml-auto">
                                        <div class="sharing">
                                            <h5>Spread the word</h5>
                                            <button class="btn btn-just-icon btn-twitter">
                                                <i class="fa fa-twitter"></i>
                                            </button>
                                            <button class="btn btn-just-icon btn-facebook">
                                                <i class="fa fa-facebook"> </i>
                                            </button>
                                            <button class="btn btn-just-icon btn-google">
                                                <i class="fa fa-google"> </i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <div class="container">
                            <div class="row">
                                <div class="media">
                                    <a class="pull-left" href="javascript:void(0)">
                                        <div class="avatar big-avatar">
                                            <img class="media-object" alt="64x64" src="./assets/img/faces/kaci-baum-2.jpg">
                                        </div>
                                    </a>
                                    <div class="media-body">
                                        <h4 class="media-heading">Sophie Banks</h4>
                                        <div class="pull-right">
                                            <a href="javascript:void(0)" class="btn btn-default btn-round "> <i class="fa fa-reply"></i> Follow</a>
                                        </div>
                                        <p>Hello guys, nice to have you on the platform! There will be a lot of great stuff coming soon. We will keep you posted for the latest news.</p>
                                        <p> Don't forget, You're Awesome!</p>

                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="comments media-area">
                                    <h3 class="text-center">Comments</h3>
                                    <div class="media">
                                        <a class="pull-left" href="javascript:void(0)">
                                            <div class="avatar">
                                                <img class="media-object" alt="Tim Picture" src="./assets/img/faces/clem-onojeghuo-3.jpg">
                                            </div>
                                        </a>
                                        <div class="media-body">
                                            <h5 class="media-heading">John Lincoln</h5>
                                            <div class="pull-right">
                                                <h6 class="text-muted">Sep 11, 11:54 AM</h6>
                                                <a href="javascript:void(0)" class="btn btn-info btn-link pull-right "> <i class="fa fa-reply"></i> Reply</a>

                                            </div>

                                            <p>Hello guys, nice to have you on the platform! There will be a lot of great stuff coming soon. We will keep you posted for the latest news.</p>

                                            <div class="media">
                                                <a class="pull-left" href="javascript:void(0)">
                                                    <div class="avatar">
                                                        <img class="media-object" alt="64x64" src="./assets/img/faces/clem-onojeghuo-2.jpg">
                                                    </div>
                                                </a>
                                                <div class="media-body">
                                                    <h5 class="media-heading">Erik P.</h5>
                                                    <div class="pull-right">
                                                        <h6 class="text-muted">Sep 11, 11:56 AM</h6>
                                                        <a href="javascript:void(0)" class="btn btn-info btn-link pull-right "> <i class="fa fa-reply"></i> Reply</a>

                                                    </div>
                                                    <p>Hello guys, nice to have you on the platform! There will be a lot of great stuff coming soon. We will keep you posted for the latest news.</p>
                                                    <p> Don't forget, You're Awesome!</p>

                                                </div>
                                            </div> <!-- end media -->
                                        </div>
                                    </div> <!-- end media -->
                                    <div class="media">
                                        <a class="pull-left" href="javascript:void(0)">
                                            <div class="avatar">
                                                <img class="media-object" alt="64x64" src="./assets/img/faces/joe-gardner-2.jpg">
                                            </div>
                                        </a>
                                        <div class="media-body">
                                            <h5 class="media-heading">Joe</h5>
                                            <div class="pull-right">
                                                <h6 class="text-muted">Sep 11, 11:57 AM</h6>
                                                <a href="javascript:void(0)" class="btn btn-info btn-link pull-right "> <i class="fa fa-reply"></i> Reply</a>

                                            </div>
                                            <p>Hello guys, nice to have you on the platform! There will be a lot of great stuff coming soon. We will keep you posted for the latest news.</p>
                                            <p> Don't forget, You're Awesome!</p>
                                        </div>
                                    </div> <!-- end media -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="related-articles">
                        <h3 class="title">Related articles</h3>
                        <legend></legend>
                        <div class="container">
                            <div class="row">
                                <div class="col-md-4">
                                    <a href="javascript:void(0)"><img src="./assets/img/sections/damir-bosnjak.jpg" alt="Rounded Image" class="img-rounded img-responsive"></a>
                                    <p class="blog-title">My Review of Pitchfork’s ‘Indie 500’ Album Review</p>
                                </div>
                                <div class="col-md-4">
                                    <a href="javascript:void(0)"><img src="./assets/img/sections/por7o.jpg" alt="Rounded Image" class="img-rounded img-responsive"></a>
                                    <p class="blog-title">Top Events This Month</p>
                                </div>
                                <div class="col-md-4">
                                    <a href="javascript:void(0)"><img src="./assets/img/sections/jeff-sheldon.jpg" alt="Rounded Image" class="img-rounded img-responsive"></a>
                                    <p class="blog-title">You Should Get Excited About Virtual Reality. Here’s Why.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<footer class="footer footer-gray">
    <div class="container">
        <div class="row">
            <nav class="footer-nav">
                <ul>
                    <li><a href="https://www.creative-tim.com">Creative Tim</a></li>
                    <li><a href="http://blog.creative-tim.com">Blog</a></li>
                    <li><a href="https://www.creative-tim.com/license">Licenses</a></li>
                </ul>
            </nav>
            <div class="credits ml-auto">
                <span class="copyright">
                    © {{data | date: 'yyyy'}}, made with <i class="fa fa-heart heart"></i> by Creative Tim
                </span>
            </div>
        </div>
    </div>
</footer>
